import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import ProductInquiryModal from '../components/ProductInquiryModal';
import HeroSection from '../components/home/HeroSection';
import ProductsPreview from '../components/home/ProductsPreview';
import FarmersSection from '../components/home/FarmersSection';
import DealersSection from '../components/home/DealersSection';
import WhyUsSection from '../components/home/WhyUsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import HappyCustomersSection from '../components/home/HappyCustomersSection';
import CtaBanner from '../components/home/CtaBanner';

export default function HomePage() {
  const navigate = useNavigate();
  const [modalProduct, setModalProduct] = useState(null);
  const openGeneralInquiry = () => setModalProduct({ name: '' });

  return (
    <main>
      <SEO
        path="/"
        description="Shree Ram Agro Industries (ARV) — Manufacturer of Rotavator (3–10 ft, 30–72 blades), Disc Harrow, Haloom Mulcher and Cultivator. Trusted by farmers across Punjab and dealers Pan-India since 2012."
        keywords="ARV rotavator, rotavator manufacturer Punjab, disc harrow, mulcher, cultivator, agricultural machinery India, ARV machinery, tractor implements"
      />
      <HeroSection onEnquire={openGeneralInquiry} onDealerClick={() => navigate('/dealers')} />
      <ProductsPreview onEnquire={setModalProduct} />
      <FarmersSection onEnquire={openGeneralInquiry} />
      <DealersSection />
      <WhyUsSection />
      <TestimonialsSection />
      <HappyCustomersSection />
      <CtaBanner onEnquire={openGeneralInquiry} />

      {modalProduct && (
        <ProductInquiryModal product={modalProduct} onClose={() => setModalProduct(null)} />
      )}
    </main>
  );
}
